import { render, staticRenderFns } from "./TimesCardReduce.vue?vue&type=template&id=139afd9e&scoped=true&"
import script from "./TimesCardReduce.vue?vue&type=script&lang=js&"
export * from "./TimesCardReduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139afd9e",
  null
  
)

export default component.exports